import type { StripeElementsOptions } from '@stripe/stripe-js'

export default {
  mode: 'payment',
  currency: 'eur',
  amount: 50,
  paymentMethodCreation: 'manual',
} as Partial<StripeElementsOptions>
